app.component("taskAutomationSetting", {
	templateUrl: "app/src/views/templates/tasks-automation.tmpl.html",
	controller: "taskAutomationSettingController",
	bindings: { practiceId: "<" },
});



app.controller("taskAutomationSettingController", [
	"$scope",
	"$mdDialog",
	"TasksAPI",
	"Session",
	"$modal",
	function ($scope, $mdDialog, TasksAPI, Session, $modal) {
		this.$onInit = function () {
			$scope.API = TasksAPI;
			$scope.$mdDialog = $mdDialog;
			$scope.Session = Session;

			// Automation rules are yours, but scoped to one practice - the rail says which.
			$scope.practiceId = this.practiceId || (Session.practice && Session.practice.id);
			const practice = (Session.practiceOptions || []).find((p) => p.id === $scope.practiceId) || Session.practice || {};
			$scope.practiceName = practice.name || "";
			$scope.setting = {};
			$scope.users = [];
			$scope.options = [
				{ name: "Referral", id: "referral_automation_settings" },
				{ name: "Surgery Waitlist", id: "surgery_waitlist_automation_settings" },
				{ name: "Progress Note", id: "progress_note_automation_settings" },
				{ name: "Injection Note", id: "injection_note_automation_settings" },
				{ name: "Operation Note", id: "operation_note_automation_settings" },
				{ name: "Histology", id: "histology_automation_settings" },
				{ name: "Premium Lens Patient Selection Form", id: "premium_lens_selection_choice_automation_settings" },
			];
			$scope.selectedCatalog = $scope.options[0].id;
			$scope.partialSetting = null;
			$scope.saveStatus = "";
			fetchSetting();
		};

		$scope.onCatalogChange = function () {
			$scope.partialSetting = $scope.setting[$scope.selectedCatalog];
			$scope.onLabelChange();
		};

		$scope.save = function () {
			$scope.API.isProcessing = true;
			$scope.saveStatus = "Saving...";
			$scope.API.updateTaskSetting($scope.setting, $scope.practiceId)
				.then(
					function (success) {
						$scope.saveStatus = "Automation saved";
					},
					function (error) {
						$scope.saveStatus = "Error saving automation";
						showErrorDialog();
					}
				)
				.then(() => ($scope.API.isProcessing = false));
		};

		$scope.onLabelChange = function(){
            const id = $scope.partialSetting && $scope.partialSetting.label_id;
            const target = id && $scope.labels.find(t=>t.task_label_id === id);
            $scope.spanStyle = { 'background-color': target ? `#${target.colour}` : 'white' };
        }

		function fetchSetting() {
			$scope.API.isProcessing = true;
			const p1 = $scope.API.getUsers($scope.practiceId);
			const p2 = $scope.API.getTaskSetting($scope.practiceId);
			const p3 = $scope.API.queryTaskLabels($scope.practiceId);

			Promise.all([p1, p2, p3])
				.then(
					(values) => {
						// The task-users endpoint returns everyone from every practice the
						// logged-in user belongs to. That is what the ad-hoc "create task"
						// screen wants, but an automation rule only ever raises tasks in
						// this practice, and these names carry no practice label to tell
						// two people of the same name apart.
						values[0].data
							.filter((doc) => doc.practiceId === $scope.practiceId)
							.forEach(function (doc) {
								if (Session.user.id === doc.id) {
									$scope.users.push({
										name: "Me (" + doc.firstName + " " + doc.lastName + ")",
										value: doc.id,
										practiceId: doc.practiceId,
									});
								} else {
									$scope.users.push({ name: doc.firstName + " " + doc.lastName, value: doc.id, practiceId: doc.practiceId });
								}
							});

						$scope.users.sort(function (a, b) {
							if (a.name < b.name) {
								return -1;
							}
							if (a.name > b.name) {
								return 1;
							}
							return 0;
						});
						
						$scope.labels = values[2].data.filter(t=>$scope.practiceId === t.practice_id);

						// Load the settings if exists. If not exists then load default settings.
						if (values[1].data.task_settings) {
							$scope.setting = values[1].data.task_settings;
						} else {
							$scope.setting = {};
						}

						if (!$scope.setting.referral_automation_settings) {
							$scope.setting.referral_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.surgery_waitlist_automation_settings) {
							$scope.setting.surgery_waitlist_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.progress_note_automation_settings) {
							$scope.setting.progress_note_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.injection_note_automation_settings) {
							$scope.setting.injection_note_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.operation_note_automation_settings) {
							$scope.setting.operation_note_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.histology_automation_settings) {
							$scope.setting.histology_automation_settings = getDefaultSettings();
						}

						if (!$scope.setting.premium_lens_selection_choice_automation_settings) {
							$scope.setting.premium_lens_selection_choice_automation_settings = getDefaultSettings();
						}

						$scope.onCatalogChange();
					},
					(error) => showErrorDialog()
				)
				.then(() => {
					$scope.API.isProcessing = false;
					$scope.$apply();
				});
		}

		$scope.positiveClick = () => {
			if ($scope.serverErrorModal) {
				$scope.serverErrorModal.hide();
				$scope.$mdDialog.hide();
			}
		};

		function getDefaultSettings() {
			const settings = {
				create_task_checked: true,
				days_until_due_date: 8,
				description: "",
				assign_to_user_id: $scope.users.length ? $scope.users[0].value : null,
				assign_to_practice_id: $scope.practiceId,
				label_id: $scope.labels.length ? $scope.labels[0].task_label_id : null
			}
			return settings;
		}

		function showErrorDialog() {
			$scope.serverErrorModal = $modal({
				scope: $scope,
				templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
				show: true,
				backdrop: "static",
				keyboard: false,
				title: "CatTrax has encountered an error",
			});
		}
	},
]);
